export default {
  // 可能是通用的
  Monthly: 'Monthly',
  Quarterly: 'Quarterly',
  Annually: 'Annually',
  Feature_List: 'Feature List',
  Unlimited: 'Unlimited',
  Subscrible: 'Subscrible',
  day: 'day',
  week: 'week',
  month: 'month',
  Download: 'Download',
  Preso_Decks: 'Preso Decks',
  count: '',

  // 独有
  // subscribe_private:{}
  AI_Chat: 'AI Chat',
  More_Perks_Included: 'More Perks Included',
  Upload_PDF: 'Upload PDF',
  Questions: 'Questions',
  AI_PPT_GenDownload: 'AI PPT Gen',
  Image_Analysis: 'Image Analysis',
  File_Analysis: 'File Analysis',
  AI_Voice_Conversation: 'AI Voice Conversation',
  Priority_Support: 'Priority Support',
  Early_Aecess_to_New_Features: 'Early Aecess to New Features',
  subscribe_c: {
    Generate: 'Image Generate'
  }
}
